import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [

    {
        "Name": "Akanksha Prajapati",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2023",
        "AreasofResearch": "Manufacturing and Tribology",
        "GuideName": "Dr. Ajay Kumar",
        "GuideLink": "/dr-ajay-kumar",
        "Email": "me23d001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Akanksha Prajapati.png"
    },
    {
        "Name": "Ch. Tejaswi Ram",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2023",
        "AreasofResearch": "Non-Linear Dynamics and Vibration",
        "GuideName": "Dr. Sriram Sundar and Prof. B. Krishna Prapoorna",
        "GuideLink": "/dr-sriram-sundar",
        "CoGuideName": "Prof. B. Krishna Prapoorna",
        "CoGuideLink": "/dr-sriram-sundar",  
        "Email": "me23d003@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Ch. Tejaswi Ram.png"
    },
    {
        "Name": "Joijode Kiran Kumar",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2023",
        "AreasofResearch": "Material and process development for additive manufacturing and post-processing of tools made of modified hot work tool steel",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",
        "Email": "me23d004@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Joijode Kiran Kumar.png"
    },
    {
        "Name": "Jonnala Subba Reddy",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2023",
        "AreasofResearch": "Control of Autonomous Robots",
        "GuideName": "Dr. Yujendra Mitikiri",
        "GuideLink": "/dr-yujendra-mitikiri",
        "Email": "me23d005@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Jonnala Subba Reddy.png"
    },
    {
        "Name": "Nitesh Kumar",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2023",
        "AreasofResearch": "Hydrogen storage",
        "GuideName": "Prof. Muthukumar Palanisamy",
        "GuideLink": "https://iittp.ac.in/prof-muthukumar-palanisamy",
        "Email": "me23d007@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Nitesh Kumar.png"
    },
    {
        "Name": "Abhishek Nath Thakur",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2022",
        "AreasofResearch": "Plastic strains-induced martensitic phase transformation",
        "GuideName": "Dr. Anup Basak",
        "GuideLink": "/dr-anup-basak",
        "Email": "me22d001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Abhishek Nath Thakur.png"
    },
    {
        "Name": "Gourav Parmar",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2022",
        "AreasofResearch": "Designing Atomizer for Efficient Capturing of Green House Gasses",
        "GuideName": "Dr. Madan Mohan Avulapati",
        "GuideLink": "/dr-madan-mohan-avulapati",
        "Email": "me22d002@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Gourav Parmar.png"
    },
    {
        "Name": "Nisar Ahamad Khan",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2022",
        "AreasofResearch": "Functionally Graded Materials, Nano-Composites, Additive Manufacturing",
        "GuideName": "Dr. Ajay Kumar",
        "GuideLink": "/dr-ajay-kumar",
        "Email": "me22d003@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Nisar Ahamad Khan.png"
    },
    {
        "Name": "Sannapareddy Anil Kumar",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2022",
        "AreasofResearch": "Design and development of modular cold storage",
        "GuideName": "Prof. E Anil Kumar",
        "GuideLink": "/dr-anil-kumar-emadabathuni",
        "Email": "me22d004@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Sannapareddy Anil Kumar.png"
    },
    {
        "Name": "Venkata Narayana S",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2022",
        "AreasofResearch": "Advanced Machining Processes",
        "GuideName": "Prof. M. Ravi Sankar, Prof. N. Venkaiah",
        "GuideLink": "/dr-mamilla-ravi-sankar, /dr-n-venkaiah",
        "Email": "me22d005@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Venkata Narayana S.png"
    },
    {
        "Name": "Suswanth Reddy Lingareddy",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2022",
        "AreasofResearch": "Interfacial wave dissipation rates (Fluid Mechanics)",
        "GuideName": "Dr. Girish Kumar Rajan",
        "GuideLink": "/dr-girish-kumar-rajan",
        // "CoGuideName": "Dr. Madan Mohan A",
        // "CoGuideLink": "/dr-madan-mohan-avulapati",  
        "Email": "me22d006@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Suswanth Reddy Lingareddy.png"
    },
    {
        "Name": "Aditya Nigam",
        "Position": "Ph.D Scholar",
        "Batch": "August 2022",
        "AreasofResearch": "Digital Twin-enabled Robot Collaborative hybrid Manufacturing System with Human-in-the-loop",
        "GuideName": "Dr. Degala Venkata Kiran",
        "GuideLink": "/dr-degala-venkata-kiran",
        "Email": "me22d501@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Aditya Nigam.png"
    },
    {
        "Name": "Avinash Mishra",
        "Position": "Ph.D Scholar",
        "Batch": "August 2022",
        "AreasofResearch": "Hybrid Manufacturing of Functionally Graded Structure",
        "GuideName": "Dr. Degala Venkata Kiran",
        "GuideLink": "/dr-degala-venkata-kiran",
        "Email": "me22d502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Avinash Mishra.png"
    },
    {
        "Name": "Dukle Amey",
        "Position": "Ph.D Scholar",
        "Batch": "August 2022",
        "AreasofResearch": "Additive Manufacturing for Biomedical Applications",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",
        "Email": "me22d503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Dukle Amey.png"
    },
    {
        "Name": "Syed Mahammad Shafi",
        "Position": "Ph.D Scholar",
        "Batch": "August 2022",
        "AreasofResearch": "Abrasive Flow Finishing of Micro Features",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",
        "Email": "me22d507@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Syed Mahammad Shafi.png"
    },
    {
        "Name": "Ashitosh Vasantrao Dange",
        "Position": "M.S (Research) Scholar",
        "Batch": "August 2022",
        "AreasofResearch": "",
        "GuideName": "Dr. Girish Kumar Rajan",
        "GuideLink": "/dr-girish-kumar-rajan",
        "Email": "me22s502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Ashitosh.png"
    },


    {
        "Name": "Nikhil Chauhan",
        "Position": "M.S (Research) Scholar",
        "Batch": "August 2022",
        "AreasofResearch": "Hydrogen storage in Metal hydrides",
        "GuideName": "Prof. P. Muthukumar",
        "GuideLink": "https://iittp.ac.in/prof-muthukumar-palanisamy",
        "Email": "me22s505@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Nikhil Chauhan.png"
    },

{
        "Name": "Umang Rastogi",
        "Position": "M.S (Research) Scholar",
        "Batch": "Jan 2022",
        "AreasofResearch": "CFD analysis and Aerodynamics",
        "GuideName": "Dr. Balaji Subramanian",
        "GuideLink": "/dr-balaji-subramanian",
        "Email": "me22s001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/umang.png"
    },

{
        "Name": "Devara Venkata Krishna",
        "Position": "Ph.D Scholar",
        "Batch": "Jul 2021",
        "AreasofResearch": "Three Dimensional Bioprinting Features",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",
        "Email": "ME21D501@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D501 DEVARA VENKATA KRISHNA.jpg"
    },

{
        "Name": "Dhananjayulu Avula",
        "Position": "Ph.D Scholar - External",
        "Batch": "Jul 2021",
        "AreasofResearch": "Tribological Aspects of Additive Manufactured Features",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",
        "CoGuideName": "Dr. M Satyanarayana ",
        "CoGuideLink": "#",  
        "Email": "ME21D502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D502 DHANANJAYULU AVULA.jpg"
    },

{
        "Name": "Hari Krishna Reddy",
        "Position": "Ph.D Scholar - External",
        "Batch": "Jul 2021",
        "AreasofResearch": "Vibrations & Acoustics",
        "GuideName": "Dr. Sriram Sundar",
        "GuideLink": "/dr-sriram-sundar",
        "CoGuideName": "Mr. Atul Miskin ",
        "CoGuideLink": "#",
        "Email": "ME21D503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D503 M. HARI KRISHNA REDDY.jpg"
    },

{
        "Name": "Santosh Kumar",
        "Position": "Ph.D Scholar - External",
        "Batch": "Jul 2021",
        "AreasofResearch": "Investigation on Fabrication and Characterization of High Frequency RF Structures and Studies of Reliability Aspects",
        "GuideName": "Dr. N.Venkaiah",
        "GuideLink": "/dr-n-venkaiah",
        "CoGuideName": "Dr. S K Datta ",
        "CoGuideLink": "#",
        "Email": "ME21D505@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D505 SANTOSH KUMAR.jpg"
    },

{
        "Name": "Satyadev Manepalli",
        "Position": "Ph.D Scholar - External",
        "Batch": "Jul 2021",
        "AreasofResearch": "Laser assisted machining of hard ceramics and its composites",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",
        "CoGuideName": "Dr. Lakshmanaro Bhagavathi ",
        "CoGuideLink": "#",
        "Email": "ME21D506@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D506 SATYADEV MANEPALLI.jpg"
    },

{
        "Name": "Srihari C",
        "Position": "Ph.D Scholar",
        "Batch": "Jul 2021",
        "AreasofResearch": "Smart manufacturing platform for hybrid tandem Wire arc additive manufacturing process",
        "GuideName": "Dr. Degala Venkata Kiran",
        "GuideLink": "/dr-degala-venkata-kiran",
        "CoGuideName": "Dr. P.S.SaiKrishna",
        "CoGuideLink": "/dr-sai-krishna",
        "Email": "ME21D507@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D507 SRIHARI C.jpg"
    },

{
        "Name": "Khushboo",
        "Position": "M.S (Research) Scholar - External",
        "Batch": "Jul 2021",
        "AreasofResearch": "Micro/ Nano Surface Texturing",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",
        "CoGuideName": "Dr. Nagahanumaiah ",
        "CoGuideLink": "#",
        "Email": "ME21S501@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21S501 KHUSHBOO.jpg"
    },

{
        "Name": "Kiran Kumar MD",
        "Position": "M.S (Research) Scholar - External",
        "Batch": "Jul 2021",
        "AreasofResearch": "Methodologies to increase the life of a Single Crystal Diamond tool for Non-ferrous and Ceramic Component",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",
        "CoGuideName": "Dr. Nagahanumaiah ",
        "CoGuideLink": "#",
        "Email": "ME21S502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21S502 KIRAN KUMAR MD.jpg"
    },

{
        "Name": "Tom Thampy",
        "Position": "M.S (Research) Scholar - External",
        "Batch": "Jul 2021",
        "AreasofResearch": "Heat and Mass Transfer",
        "GuideName": "Dr. Madan Mohan Avulapati",
        "GuideLink": "/dr-madan-mohan-avulapati",
        "CoGuideName": "Dr. Nagahanumaiah ",
        "CoGuideLink": "#",        
        "Email": "ME21S503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21S503 TOM THAMPY.JPG"
    },

{
        "Name": "Pujari Siddesh Santhosh Shital",
        "Position": "M.S (Research) Scholar",
        "Batch": "Jul 2021",
        "AreasofResearch": "Computational Fluid Dynamics",
        "GuideName": "Dr. Girish Kumar Rajan",
        "Email": "ME21S504@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21S504 PUJARI SIDDHESH SANTOSH SHITAL.jpg"
    },    
        {
            "Name": "Sarmistha Dhan",
            "Position": "M.S (Research) Scholar - External",
            "Batch": "Jul 2021",
            "AreasofResearch": "Advanced Coatings",
            "GuideName": "Prof. Mamilla Ravi Sankar",
            "GuideLink": "/dr-mamilla-ravi-sankar",
            "CoGuideName": "Dr. Nagahanumaiah ",
            "CoGuideLink": "#",
            "Email": "ME21S505@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21S505 SARMISTHA DHAN.jpg"
        },
        {
            "Name": "Ankit K",
            "Position": "Ph.D Scholar (External)",
            "Batch": "Jan 2021",
            "AreasofResearch": "Synthesis of carbon-based thin films for sensing and mechanical applications",
            "GuideName": "Prof. Mamilla Ravi Sankar",
            "GuideLink": "/dr-mamilla-ravi-sankar",
            "Email": "ME21D001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D001 ANKIT K.jpg"
        },
        {
            "Name": "Dipayan Chakraborty",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2021",
            "AreasofResearch": "Forging, Mechanical and Microstructural study of Titanium alloy for compressor airfoils",
            "GuideName": "Dr. Ajay Kumar",
            "GuideLink": "/dr-ajay-kumar",
            "Email": "ME21D004@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D004 DIPAYAN CHAKRABORTY.jpg"
        },
        {
            "Name": "Prodduturu Dasthagiri",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2021",
            "AreasofResearch": "Adsorption Refrigeration System",
            "GuideName": "Dr. Anil Kumar Emadabathuni",
            "GuideLink": "/dr-anil-kumar-emadabathuni",
            "Email": "ME21D007@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D007 PRODDUTURU DASTHAGIRI.jpg"
        },
        {
            "Name": "Tadi Siva Prasad",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2021",
            "AreasofResearch": "Sustainable manufacturing of metal & ceramic particle filled polymer filaments for advanced manufacturing applications",
            "GuideName": "Prof. Mamilla Ravi Sankar",
            "GuideLink": "/dr-mamilla-ravi-sankar",
            "Email": "ME21D008@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D008 TADI SIVA PRASAD.jpg"
        },
        {
            "Name": "Vimal Kumar Jain",
            "Position": "Ph.D Scholar - External",
            "Batch": "Jan 2021",
            "AreasofResearch": "Laser Assisted Machining (LAM) for Advanced Hard And Brittle Materials",
            "GuideName": "Prof. Mamilla Ravi Sankar",
            "GuideLink": "/dr-mamilla-ravi-sankar",
            "Email": "ME21D009@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D009 VIMAL KUMAR JAIN.jpg"
        },
        {
            "Name": "Pranjal Shukla",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2020",
            "AreasofResearch": "Smart Manufacturing.",
            "GuideName": "Dr. D.V. Kiran",
            "GuideLink": "/dr-degala-venkata-kiran",
            "Email": "me20d004@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/pranjal.jpg"
        },
        {
            "Name": "P. Sai Chaitanya",
            "Position": "Ph.D Scholar",
            "Batch": "July 2021 (External)",
            "AreasofResearch": "Liquid Atomization and carbon capture.",
            "GuideName": "Dr. Madan Mohan Avulapati",
            "GuideLink": "/dr-madan-mohan-avulapati",
            "Email": "me21d508@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME21D508.jpg"
        },
        {
            "Name": "Md Imran",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2021",
            "AreasofResearch": "Design and Development of Solar Powered Long Endurance Drone Based Wind Measurement System.",
            "GuideName": "Dr. Balaji Subramanian",
            "GuideLink": "/dr-balaji-subramanian",
            "Email": "me21d006@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/imran.jpg"
        },
        {
            "Name": "Basharat Ahmad Wani",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2021",
            "AreasofResearch": "Damage Analysis Of Advanced Fiber Reinforced Polymer Composites.",
            "GuideName": "Dr. Subbareddy Daggumati",
            "GuideLink": "/dr-subbareddy-daggumati",
            "Email": "ME21D002@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ahmad.jpeg"
        },
        {
            "Name": "Deepak Singh D",
            "Position": "M.S (Research) Scholar - External",
            "Batch": "Jan 2020",
            "AreasofResearch": "Laser micromachining of soft materials for advanced applications",
            "GuideName": "Prof. Mamilla Ravi Sankar",
            "GuideLink": "/dr-mamilla-ravi-sankar",
            "Email": "ME20S002@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20S002 Deepak Singh D.jpg"
        },
        {
            "Name": "A Narayana Teja",
            "Position": "M.S (Research) Scholar - External",
            "Batch": "Jul 2020",
            "AreasofResearch": "Study of thermal cycling in rotor segments for life assessment and utilization in power plants.",
            "GuideName": "Dr. Balaji Subramanian",
            "GuideLink": "/dr-balaji-subramanian",
            "Email": "ME20S503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20S503 A Narayana Teja.jpg"
        },
    {
        "Name": "Bhakara Kishore CH",
        "Position": "Ph.D Scholar - External",
        "Batch": "Jul 2020",
        "AreasofResearch": "Automotive Dynamics",
        "GuideName": "Dr. Sriram Sundar",
        "GuideLink": "/dr-sriram-sundar",
        "Email": "ME20D502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20D502 Bhaskara Kishore Ch.jpg"
    },
    {
        "Name": "M Ramesh",
        "Position": "M.S (Research) Scholar",
        "Batch": "Jul 2020",
        "AreasofResearch": "Sustainable machining",
        "GuideName": "Dr. M. Ravi Sankar ",
        "GuideLink": "/dr-mamilla-ravi-sankar", 
        "CoGuideName": "Dr. Madan Mohan A",
        "CoGuideLink": " /dr-madan-mohan-avulapati",  
        "Email": "ME20S502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20S502 M RAMESH.jpg"
    },
    {
        "Name": "Mithun Sundhar B",
        "Position": "M.S (Research) Scholar",
        "Batch": "Jan 2020",
        "AreasofResearch": "Fluid Mechanics",
        "GuideName": "Dr. Girish Kumar Rajan",
        "GuideLink": "/dr-girish-kumar-rajan",
        "Email": "ME20S003@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20S003 Mithun Sundhar B.jpg"
    },
    {
        "Name": "S Mujahid",
        "Position": "M.S (Research) Scholar",
        "Batch": "Jan 2020",
        "AreasofResearch": "CFD Analysis of wind turbines",
        "GuideName": "Dr. Balaji Subramanian",
        "GuideLink": "/dr-balaji-subramanian",
        "Email": "ME20S004@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20S004 Mujahid.JPG"
    },
    {
        "Name": "Tumula Tirumala",
        "Position": "Ph.D Scholar",
        "Batch": "Jul 2020",
        "AreasofResearch": "Development and Tribological Study of Surface Alloy Coatings for Water Industry Components",
        "GuideName": "Dr. Ajay Kumar",
        "GuideLink": "/dr-ajay-kumar",
        "Email": "ME20D508@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20D508 TUMULA TIRUMALA.jpg"
    },
    {
        "Name": "Ramesh Kumar B",
        "Position": "Ph.D Scholar",
        "Batch": "Jul 2020",
        "AreasofResearch": "Additive Manufacturing",
        "GuideName": "Dr. M. Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",
        "Email": "ME20D506@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20D506 RAMESH KUMAR B.JPG"
    },
    {
        "Name": "Palivela Bhargav Chandan",
        "Position": "Ph.D Scholar",
        "Batch": "Jul 2020",
        "AreasofResearch": "Nano Finishing of complex 3D printed components using polymer rheological abrasive medium",
        "GuideName": "Dr. M. Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",
        "Email": "ME20D504@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20D504 BhargavChandan Palivela.jpg"
    },
    {
        "Name": "Newton",
        "Position": "Ph.D Scholar",
        "Batch": "Jul 2020",
        "AreasofResearch": "Solid Mechanics and Design",
        "GuideName": "Dr. Anup Basak",
        "GuideLink": "/dr-anup-basak",
        "Email": "ME20D503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20D503 NEWTON.jpg"
    },
    {
        "Name": "Sangeeth Purushothaman",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2020",
        "AreasofResearch": "Laser Machining ",
        "GuideName": "Dr. N. Venkaiah ",
        "GuideLink": "/dr-n-venkaiah",
        "CoGuideName": "Dr. M. Ravi Sankar ",
        "CoGuideLink": "/dr-mamilla-ravi-sankar",  
        "Email": "ME20D005@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20D005%20Sangeeth%20Purushothaman.jpg"
    },   
    {
        "Name": "Maddula Shanmuka Srinivas",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2020",
        "AreasofResearch": "Sustainable Machining",        
        "GuideName": "Dr. N. Venkaiah ",
        "GuideLink": "/dr-n-venkaiah",
        "CoGuideName": "Dr. M. Ravi Sankar ",
        "CoGuideLink": "/dr-mamilla-ravi-sankar",  
        "Email": "ME20D002@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20D002 M Shanmuka Srinivas.jpg"
    },
    {
        "Name": "Akkala Yakanna",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2020",
        "AreasofResearch": "Fatigue life estimation of CFRP curved composite laminate",
        "GuideName": "Dr. Subba Reddy D",
        "Email": "ME20D001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME20D001 Akkala Yakanna.jpg"
    },
    {
        "Name": "P V Divakar Raju",
        "Position": "Ph.D Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Natural Fiber Composites",
        "GuideName": "Dr. P Venkataraman, Dr. M Nithyadharan",
        "Email": "me19d506@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/civil/Divakar_Raju.png"
    },
    {
        "Name": "Manjunath B N",
        "Position": "M.S (Research) Scholar External",
        "Batch": "July 2019",
        "AreasofResearch": "Additive Manufacturing",
        "GuideName": "Dr. N. Venkaiah, ",
        "GuideLink": "/dr-n-venkaiah",  
        "CoGuideName": "Dr. D. Venkata Kiran",
        "CoGuideLink": "/dr-degala-venkata-kiran",  
        "Email": "me19s504@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/dummy.jpg"
    },
    {
        "Name": "Manjunath M.A",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Super Finishing Technology",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "Email": "me19s505@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/manjunath.jpg"
    },
    {
        "Name": "Karthik M S",
        "Position": "M.S (Research) Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Micromachining",
        "GuideName": "Dr. N.Venkaiah,",
        "GuideLink": "/dr-n-venkaiah",  
        "CoGuideName": "Prof. Mamilla Ravi Sankar",
        "CoGuideLink": "/dr-mamilla-ravi-sankar",  
        "Email": "me19s502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/karthik.jpg"
    },
    {
        "Name": "Dinesh Dashbabu",
        "Position": "Ph.D Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Metal Hydride Based Hydrogen Compressors",
        "GuideName": "Dr. Anil Kumar Emadabathuni",
        "Email": "me19s502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/DINESH.jpg"
    },
    {
        "Name": "Kumar Milind Rewanand Shripad",
        "Position": "M.S (research) Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Contact Mechanics",
        "GuideName": "Dr. Sriram Sundar,",
        "GuideLink": "/dr-sriram-sundar",  
        "CoGuideName": "Dr. P. Venkataraman",
        "CoGuideLink": "/dr-p-venkataraman",  
        "Email": "me19s503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME19S503_Photo.jpg"
    },
    {
        "Name": "Adapa Mahanth Kumar",
        "Position": "Ph.D Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Narrow Groove Joining of HSLA steels using Two wire tandem submerged arc welding process",
        "GuideName": "Dr. Degala Venkata Kiran",
        "GuideLink": "/dr-degala-venkata-kiran",  
        "CoGuideName": " Dr. N.Venkaiah",
        "CoGuideLink": "/dr-n-venkaiah",  
        "Email": "me19d501@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/AMK.jpg"
    },
    {
        "Name": "Mulla Mahaboob Basha",
        "Position": "Ph.D Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Sustainable Machining of Advanced Materials",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",  
        "CoGuideName": "Dr. N.Venkaiah",
        "CoGuideLink": "/dr-n-venkaiah",  
        "Email": "me19d505@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/mahaboob.jpg"
    },

    {
        "Name": "Shaik Mahaboob Basha ",
        "Position": "Ph.D Scholar",
        "Batch": "July 2019",
        "AreasofResearch": "Abrasive Nano Finishing Process ",
        "GuideName": "Prof. Mamilla Ravi Sankar",
        "GuideLink": "/dr-mamilla-ravi-sankar",        
        "CoGuideName": "Dr. N.Venkaiah",
        "CoGuideLink": "/dr-n-venkaiah",
        "Email": "me19d505@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/pics/researchscholars/me/basha.jpg"
    },
   
        {
            "Name": "Bandaru Chandrakala",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Second Law Analysis Of Adsorption Process",
            "GuideName": "Dr. Anil Kumar Emadabathuni",
            "Email": "me19d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/chandrakala.jpg"
        },
        {
            "Name": "Shaik Sadikbasha",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Multiscale Modeling",
            "GuideName": "Dr. P. Venkataraman",
            "Email": "me19d508@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/Sadikbasha.jpg"
        },
        {
            "Name": "P V Divakar Raju",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Natural Fiber Composites",
            "GuideName": "Dr. P. Venkataraman",
            "GuideLink": "/dr-sriram-sundar",  
            "CoGuideName": "Dr.M.Nithyadharan",
            "CoGuideLink": "/dr-nithyadharan",  
            "Email": "me19d506@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/diwakar.jpeg"
        },
        {
            "Name": "Vignesh Kumar D",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "High viscosity liquid atomization for spray drying",
            "GuideName": "Dr. Madan Mohan Avulapati",
            "Email": "me19d509@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/vignesh.jpg"
        },
        {
            "Name": "S.Harshavardhan Reddy",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2019",
            "AreasofResearch": "Wind Turbines",
            "GuideName": "Dr. Balaji Subramanian",
            "Email": "me19d001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/harshavardhan.jpg"
        },
        {
            "Name": "Vinod A.R.",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2019",
            "AreasofResearch": "Additive Manufacturing",
            "GuideName": "Dr. N.Venkaiah",
            "Email": "me19s002@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/me/ME19S002_VinodAR.jpg"
        },
        {
            "Name": "P Vinod Kumar Naidu",
            "Position": "Ph.D Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Multi Component Fuel Blend Combustion",
            "GuideName": "Dr. Madan Mohan Avulapati",
            "Email": "me18d503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/ME18D503_PVINODKUMARNAIDU.jpg"
        },
        {
            "Name": "Polamuri Sudheer Kumar",
            "Position": "Ph.D Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Metallurgical-Mechanical characterization of Twin wire additive manufactured parts",
            "GuideName": "Dr. N.Venkaiah",
            "GuideLink": "/dr-n-venkaiah",  
            "CoGuideName": "Dr.Degala Venkata Kiran",
            "CoGuideLink": "/dr-degala-venkata-kiran",  
            "Email": "me18d504@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/me18d504_Psudheerkumar.png"
        },
        {
            "Name": "Yella Akash",
            "Position": "Ph.D Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Non Linear Dynamics and Vibrations",
            "GuideName": "Dr. Sriram Sundar",
            "Email": "me18d506@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/Akash.jpg"
        },
        {
            "Name": "Ananthapadmanabhan R",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2017",
            "AreasofResearch": "Vibration and Brake Dynamics",
            "GuideName": "Dr. Sriram Sundar",
            "Email": "me17ms001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/padmanabhan.jpg"
        },
        {
            "Name": "K. Sarath Babu",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2018",
            "AreasofResearch": "Thermochemical Energy Storage",
            "GuideName": "Dr. Anil Kumar E",
            "Email": "me18d001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/sarath.jpg"
        },
        {
            "Name": "Kasani Tirupataiah",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2018",
            "AreasofResearch": "Manufacturing Sciences",
            "GuideName": "Dr. N.Venkaiah",
            "CoGuideLink": "/dr-n-venkaiah",  
            "CoGuideName": "Dr.D.V Kiran",
            "CoGuideLink": "/dr-degala-venkata-kiran",  
            "Email": "me18d002@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/kasani.jpg"
        },
        {
            "Name": "Kedar Bharat Jivrakh",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2017",
            "AreasofResearch": "Thermochemical Energy Storage",
            "GuideName": "Dr. Anil Kumar E",
            "Email": "me17ms003@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/kedarbharat.jpg"
        },
        {
            "Name": "Manohar Tamarana",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2017",
            "AreasofResearch": "Non-Destructive Testing",
            "GuideName": "Prof N.N.Kishore",
            "GuideLink": "/dr-n-n-kishore",     
            "CoGuideName": "Dr.Sriram Sundar",
            "CoGuideLink": "/dr-sriram-sundar",     
            "Email": "me17ms004@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/manohar.jpg"
        },
        {
            "Name": "Nikhil Kumar Etteneni",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2017",
            "AreasofResearch": "Impinging Jet Atomization",
            "GuideName": "Dr. Madan Mohan Avulapati",
            "Email": "me17ms002@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/dummy.jpg"
        }
    

    












]



function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Mechanical Engineering" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Research Scholars
                                </h5>
                                <h2>Mechanical Engineering</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (
       

                           <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="#">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.Name}</Link>
                                        </h4>
                                       
                                        <div className="text-dark c-lineheight2">
                                            <p > <i className="fal fa-graduation-cap me-2" />{teacher.Position}</p>
                                            <p className="text-dark">{teacher.position2}</p>
                                            <p className="text-dark">Batch : {teacher.Batch}</p>
                                            <p className="text-dark">Areas of Research : {teacher.AreasofResearch}</p>
                                            
                                            {/* Parse the HTML content and extract text */}
                                            
                                            <p className="text-dark">Guide: <Link className="text-maroon" to={teacher.GuideLink} target="_blank" > {teacher.GuideName}</Link> </p>

                                            {(teacher.CoGuideName !== undefined && teacher.CoGuideName !== "") && (
                                                <p className="text-dark">Co-Guide: <a className="text-maroon" href={teacher.CoGuideLink} target="_blank" >{teacher.CoGuideName}</a></p>
                                            )}

                                            

                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.Email} target="_blank" className="btn btn-primary">{teacher.Email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {teacher.Email}</p>
                                        </div>                                       
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main